module.exports = __webpack_public_path__ + "/login_ui/img/la-79a72be9c21cd63fbce9c2fdacb16c7d.svg";